export const COMPANIES = "companies";
export const DASHBOARD = "dashboard";
export const DESKTOP_LICENSES = "desktopLicenses";
export const DEVICE_MODELS = "deviceModels";
export const DEVICES = "devices";
export const FILES = "files";
export const GROUPS = "groups";
export const PRODUCT_CODES = "productCodes";
export const TASKS = "tasks";
export const USERS = "users";
